import { Component, OnInit, input, output, signal } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import {
  QaiDragHandleDirective,
  QaiFieldComponent,
  QaiIconComponent,
  QaiPasteCleanDirective,
  QaiTextareaComponent,
  QaiTrimLeadingDirective,
  TextareaAutosizeDirective,
} from '@qai/ui';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { AuthorReactiveFormService } from 'src/app/pages/self-serve/simulation-builder/services/author-reactive-form.service';
import { SelfServeLocalStorageUtil } from 'src/app/utils/local-storage.util';

@Component({
  selector: 'messaging-theme-fact-flat',
  standalone: true,
  templateUrl: './messaging-theme-fact-flat.component.html',
  styleUrls: ['./messaging-theme-fact-flat.component.scss'],
  imports: [
    ReactiveFormsModule,
    QaiIconComponent,
    QaiDragHandleDirective,
    QaiFieldComponent,
    QaiTextareaComponent,
    TextareaAutosizeDirective,
    QaiTrimLeadingDirective,
    QaiPasteCleanDirective,
    TranslocoModule,
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'simulationBuilder' }],
})
export class MessagingThemeFlatFactComponent implements OnInit {
  currentFact = input.required<FormGroup>();
  factIndex = input.required<number>();
  readOnly = input(false);
  isLast = input(false);

  deleteFactRequested = output<{ index: number; factUuid: string }>();

  callUuid: string = '';
  showIncorrectText = signal(false);

  constructor(
    private route: ActivatedRoute,
    private authorReactiveFormService: AuthorReactiveFormService,
  ) {}

  ngOnInit(): void {
    this.callUuid = this.route.snapshot.paramMap?.get('uuid')!;
    this.authorReactiveFormService.setReadOnlyMode(
      this.callUuid,
      this.currentFact().get('rawText')!,
    );
    this.authorReactiveFormService.setReadOnlyMode(
      this.callUuid,
      this.currentFact().get('displayTextIncorrect')!,
    );

    const factUuid = this.currentFact().get('uuid')?.value;
    const hasIncorrectText = !!this.currentFact()
      .get('displayTextIncorrect')
      ?.value?.trim();
    this.showIncorrectText.set(
      hasIncorrectText ||
        SelfServeLocalStorageUtil.isIncorrectTextRevealed(factUuid),
    );
  }

  handleDeleteFact(): void {
    this.deleteFactRequested.emit({
      index: this.factIndex(),
      factUuid: this.currentFact().value.uuid,
    });
  }

  revealIncorrectText(): void {
    this.showIncorrectText.set(true);
    const factUuid = this.currentFact().get('uuid')?.value;
    if (factUuid) {
      SelfServeLocalStorageUtil.setIncorrectTextRevealed(factUuid);
    }
  }
}
